<style scoped>
  .layout {
    /* border: 1px solid #d7dde4; */
    /* background: #f5f7f9; */
    /* position: relative; */
    /* border-radius: 4px; */
    /* overflow: hidden; */
    font-size: 12px;
    color: rgb(73, 80, 96);
    text-align: center;
  }

  .caption {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .stoploss {
    /*color: darkorange;*/
    color:var(--color-danger-light);
  }

  .takeprofit {
    /*color: green;*/
    color: var(--color-success-light);
  }

  div {
    /*border: 1px solid antiquewhite;*/
  }

  .box {
    /* border: 3px dotted blue; */
    /* height: 400px; */
    /* width: 500px; */
    /* background: lightsteelblue; */
    /* background: #ededed; */
    /* background: lightgray; */
    background: var(--color-background-dark);
    border-radius: 5px;
    margin-right: 0px;
    padding: 20px;
    border: 1px solid var(--color-accent-dark);
    padding-top: 6px;
    grid-area: header;
  }

  .meditation-box {
    text-align: center;
    height: 460px;
    padding-top: 50px;
    color: var(--color-neutral);
    font-size: 17px;
  }

  #headergrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    grid-template-areas: "qty prices";
  }
  #box-grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "header header"
      "slswitcher tpswitcher"
      "sl tp";
  }

  @media all and (max-width: 800px) {
    #headergrid {
      grid-template-colums: 1fr;
      grid-template-areas:
        "qty"
        "prices";
    }
    #box-grid {
      grid-template-areas:
        "header"
        "slswitcher"
        "sl"
        "tpswitcher"
        "tp";
      grid-template-columns: 1fr;
    }
    #tpswitcher {
      margin-top: 10px;
    }
  }
  #qty {
    grid-area: qty;
  }
  #prices {
    grid-area: prices;
  }
  #slswitcher {
    grid-area: slswitcher;
  }
  #tpswitcher {
    grid-area: tpswitcher;
  }
  #sl {
    grid-area: sl;
  }
  #tp {
    grid-area: tp;
  }
  .flexbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .header-text {
    color: var(--color-text-dark);
    min-width: 120px;
  }
</style>

<template>
  <div>
    <Modal
      v-model="$store.state.sltpModal"
      title="STOP LOSS / TAKE PROFIT"
      width="960px"
      @on-ok="ok"
      @on-cancel="cancel"
      :loading="loading"
      :mask-closable="false"
      :ok-text="$store.state.sltpTrade ? $text.tr('СОХРАНИТЬ'): $text.tr('СОЗДАТЬ СДЕЛКУ')"
      :cancel-text="$text.tr('ЗАКРЫТЬ')">
      <!--  MODAL START -->
      <div id="box-grid">
      <div class="box" style="margin-bottom: 20px; font-size: 14px;">
        <div style="margin-bottom: 10px;">
          <span v-if="side === 'B'" style="color: var(--color-success-light);">{{ $text.tr('LONG СДЕЛКА (покупка)') }}</span>
          <span v-if="side === 'S'" style="color:var(--color-danger-light);">{{ $text.tr('SHORT СДЕЛКА (продажа)') }}</span>
          <Tooltip v-if="side === 'S'" max-width="240" placement="right-start" :content="$text.tr('При продаже актива Stop Loss устанавливается выше текущей цены, а Take Profit - ниже')">
            <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
          </Tooltip>
          <Tooltip v-if="side === 'B' && !$store.state.sltpTrade" max-width="240" placement="right-start" :content="$text.tr('При указании цены покупки и/или добавлении параметров Stop Loss/Take Profit система разместит ордер в разделе активные сделки для дальнейшего его отслеживания')">
            <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
          </Tooltip>
        </div>
        <div id="headergrid">
          <div id="qty">
            <div class="flexbox">
              <div class="header-text">
                {{ $text.tr('КОЛИЧЕСТВО:') }}
              </div>
              <div v-if="$store.state.sltpTrade">
                <strong>
                  {{ curAsset.Qty }} {{ asset }}
                </strong>
              </div>
              <div v-if="!$store.state.sltpTrade" style="display: flex; justify-content: space-between">
                <i-input v-model="qty" style="width: 190px;" :class="{ errored: qtyError!=='' }" @on-keydown="onkeyDown(qty,$event)" @on-change="qtyChangedEvent">
                  <span slot="append">{{ curAsset.Coin }}</span>
                </i-input>
                <Button style="margin-left: 20px; height: 32px; border: 1px solid #6b74e7" size="small" @click="amount100()">100%</Button>
              </div>
            </div>
            <div v-if="!$store.state.sltpTrade" style="font-size: 11px; color:var(--color-danger-light); height: 12px;">{{ qtyError }} <a href="https://youtu.be/ZohP-IxBVxU" target="_blank" style="text-decoration: underline; color:var(--color-danger-light);" v-if="qtyError"><br/>{{ $text.tr('Подробнее') }}</a></div>
          </div>
          <div id="prices">
            <div class="flexbox">
              <div class="header-text">
                <span v-if="side === 'B'">{{ $text.tr('ЦЕНА ПОКУПКИ: ') }}</span>
                <span v-if="side === 'S'">{{ $text.tr('ЦЕНА ПРОДАЖИ: ') }}</span>
              </div>
              <div>
                <div v-if="$store.state.sltpTrade">
                  <strong>
                    {{ this.buyPrice }} {{ this.sellAsset }}
                  </strong>
                </div>
                <div v-if="!$store.state.sltpTrade">
                  <i-input style="width: 190px;" v-model="buyPrice" @on-change="buyPriceChanged">
                    <Select slot="append" style="width: 70px;" v-model="sellAsset" @on-change="sltpAssetChanged">
                      <Option v-for="asset in curAsset.QuoteAssets" :key="asset.Asset" :value="asset.Asset">
                        {{ asset.Asset }}
                      </Option>
                    </Select>
                  </i-input>
                </div>
            </div>
            </div>
            <div class="flexbox" style="margin-top: 15px;">
              <div class="header-text">
                {{ $text.tr('ТЕКУЩАЯ ЦЕНА:') }}
              </div>
              <strong>{{ this.curAssetPrices[this.sellAsset] }} {{ this.sellAsset }}</strong>
            </div>
          </div>
        </div>
      </div>
<!--      Stop loss-->
      <div id="slswitcher">
        <div class="caption stoploss">
          <Tooltip max-width="240" style="font-weight: normal" placement="bottom" :content="$text.tr('Позволяет зафиксировать нижнюю границу прибыли, если сделка уже в плюсе, либо ограничить убыток, когда цена движется в невыгодном для трейдера направлении')">
            <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
          </Tooltip>
          Stop Loss &nbsp;&nbsp;
          <i-switch v-model="stopLossShow" @on-change="checkErrors"/>
        </div>
      </div>
<!--      Take profit-->
      <div id="tpswitcher">
        <div class="caption takeprofit">
          <Tooltip max-width="240" style="font-weight: normal" placement="bottom" :content="$text.tr('Позволяет закрыть сделку с прибылью, когда цена движется в нужном для трейдера направлении')">
            <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
          </Tooltip>
          Take Profit &nbsp;&nbsp;
          <i-switch v-model="takeProfitShow" @on-change="checkErrors"/>
        </div>
      </div>
      <div id="sl">
        <span v-if="!stopLossShow" style="opacity: 0">1</span>
        <div v-show="stopLossShow" class="box" style="padding-top:20px;margin-top: 20px; margin-right: 10px;">
          <i-input :value="stopLossPrice" :class="{ errored: slpriceError!=='' }" size="large" @on-keydown="onkeyDown(stopLossPrice,$event)" @on-change="stopLossPriceChangedEvent">
            <span v-if="side == 'B'" slot="prepend" style="font-size: 16px;">{{ $text.tr('Цена продажи') }}</span>
            <span v-if="side == 'S'" slot="prepend" style="font-size: 16px;">{{ $text.tr('Цена выкупа') }}</span>
            <!--<span slot="append" style="width: 70px;">{{ curAsset.Sltp.SellAsset }}</span>-->
            <Select slot="append" style="width: 70px;" v-model="sellAsset" @on-change="sltpAssetChanged">
              <Option v-for="asset in curAsset.QuoteAssets" :key="asset.Asset" :value="asset.Asset">
                {{ asset.Asset }}
              </Option>
            </Select>
          </i-input>
          <div style="font-size: 12px; color:var(--color-danger-light); height: 12px;">{{ slpriceError ? slpriceError : slAmountError }}</div>
          <div v-if="side == 'B'">
            <div style="margin-top: 20px;">{{ $text.tr('Изменение от цены покупки') }}, %</div>
            <Slider :value="stopLossPct" @on-change="stopLossPctChangedEvent" show-tip="never"
                    :min="-50.0 + maxFloat"
                    :max="maxFloat"
                    :step="0.1"
                    input-size="large"
                    show-input></Slider>
          </div>
          <div v-if="side == 'S'">
            <div style="margin-top: 20px;">{{ $text.tr('Изменение от цены продажи') }}, %</div>
            <Slider :value="stopLossPct" @on-change="stopLossPctChangedEvent" show-tip="never"
                    :min="minFloat"
                    :max="100+minFloat"
                    :step="0.1"
                    input-size="large"
                    show-input></Slider>
          </div>

          <div style="height: 24px"></div>

          <div style="margin-top: 36px; padding-top:0px;">
            <span>Trailing</span>
            <Tooltip style="color: var(--color-neutral)" max-width="240" placement="bottom" :content="$text.tr('Позволяет уровню Stop Loss следовать за изменением цены, максимально отклоняясь от нее на величину заданного процента. Тем самым потери минимизируются, a в некоторых случаях можно закрыть сделку с прибылью')">
              <Icon type="ios-information-circle-outline"></Icon>
            </Tooltip>
            &nbsp;
            <i-switch v-model="slTrailing"/>
          </div>
          <div v-if="expLossPct < 0" style="margin-top: 24px;">
            {{ $text.tr('Ожидаемый убыток:') }} <span style="font-size: 14px;color:var(--color-danger-light); font-weight: bold;">{{ expLoss }} {{ this.sellAsset }} ({{ expLossPct }}%)</span>
          </div>
          <div v-if="expLossPct >= 0" style="margin-top: 24px;">
            {{ $text.tr('Ожидаемая прибыль:') }} <span style="font-size: 14px;color: var(--color-success-light); font-weight: bold;">{{ expLoss }} {{ this.sellAsset }} ({{ expLossPct }}%)</span>
          </div>
        </div>
      </div>
      <div id="tp">
        <div v-show="takeProfitShow" class="box" style="padding-top:20px;margin-top: 20px;  margin-left: 10px;">

          <div v-if="showStepsTable">
            <table style="width:400px; margin-bottom: 10px;">
              <tr style="text-align: left;">
                <th>{{ $text.tr('Цена') }}</th>
                <th>{{ $text.tr('Кол-во') }}</th>
                <th>{{ $text.tr('Сумма') }}</th>
                <th></th>
              </tr>
              <tr v-for="(step, index) in steps" :key="'step-' + index">
                <td style="width:50px;">{{ step.Price }}</td>
                <td style="width:40px;">{{ step.Pct }}%</td>
                <td style="width:60px;">{{ step.Qty }} {{ asset }}</td>
                <td style="width:30px;">
                  <Icon v-if="step.Status !== 'EXC'" style="cursor: pointer;" type="md-close" @click="deleteStep(index)"/>
                  <Icon v-if="step.Status === 'EXC'" type="md-checkmark" />
                </td>
              </tr>
            </table>
          </div>
          <div v-if="showPriceAndPct">
            <i-input :value="takeProfitPrice" :class="{ errored: tppriceError!=='' }" size="large" @on-keydown="onkeyDown(takeProfitPrice,$event)"  @on-change="takeProfitPriceChangedEvent">
              <span v-if="side === 'B'" slot="prepend" style="font-size: 16px;">{{ $text.tr('Цена продажи') }}</span>
              <span v-if="side === 'S'" slot="prepend" style="font-size: 16px;">{{ $text.tr('Цена выкупа') }}</span>
              <Select slot="append" style="width: 70px;" v-model="sellAsset" @on-change="sltpAssetChanged">
                <Option v-for="asset in curAsset.QuoteAssets" :key="asset.Asset" :value="asset.Asset">
                  {{ asset.Asset }}
                </Option>
              </Select>
            </i-input>
            <div style="font-size: 12px; color:var(--color-danger-light); height: 12px;">{{ tppriceError ? tppriceError : tpAmountError ? tpAmountError : tpStepAmountError }}</div>
            <div v-if="side == 'B'">
              <div style="margin-top: 20px;">{{ $text.tr('Изменение от цены покупки') }}, %</div>
              <Slider :min="minFloat" :max="minFloat+100" :step="0.1" :value="takeProfitPct"
                      @on-change="takeProfitPctChangedEvent" input-size="large" show-input
                      show-tip="never"></Slider>
            </div>
            <div v-if="side == 'S'">
              <div style="margin-top: 20px;">{{ $text.tr('Изменение от цены продажи') }}, %</div>
              <Slider :max="maxFloat" :min="-50.0+maxFloat" :step="0.1" :value="takeProfitPct"
                      @on-change="takeProfitPctChangedEvent" input-size="large" show-input
                      show-tip="never"></Slider>
            </div>
          </div>
          <div v-if="showAddTarget">
            <div style="margin-top: 20px;">{{ $text.tr('Кол-во') }}, %</div>
            <Slider v-model="stepAmountPct" show-tip="never" :min="1"
                    :max="maxStepPct" :step="1" input-size="large"
                    show-input></Slider>
          </div>

          <Button v-if="showAddSteps" long style="margin-top: 10px;" @click="addSteps()">
            {{ $text.tr('ДОБАВИТЬ ЛЕСЕНКУ') }}
          </Button>
          <Button v-if="showAddTarget" :disabled="tpStepAmountError !== ''" long style="margin-top: 10px;" @click="addTarget() ">
            {{ $text.tr('ДОБАВИТЬ ЦЕЛЬ') }}
          </Button>

          <div style="margin-top: 10px;">
            <Row style="height: 24px;">
              <i-col span="11" style="margin: 6px 0;">
                <span>Trailing</span>
                <Tooltip max-width="245" placement="bottom" :content="$text.tr('Делает последнюю цель Take Profit динамически изменяемой. Закрытие сделки произойдет не моментально, а только когда прекратится движение актива в нужном для трейдера направлении, и значение цены отклонится на заданную величину процента')">
                  <Icon style="color: var(--color-neutral)" type="ios-information-circle-outline"></Icon>
                </Tooltip>
                &nbsp;
                <i-switch v-model="tpTrailing" />
              </i-col>
              <i-col span="13">
                <Slider v-show="tpTrailing" v-model="tpTrailingPct" show-tip="never" :min="0.1"
                        :max="20.0" :step="0.1" input-size="large"
                        show-input></Slider>
              </i-col>
            </Row>

          </div>
          <div v-if="expProfitPct < 0" style="margin-top: 30px;">
            {{ $text.tr('Ожидаемый убыток:') }} <span style="font-size: 14px;color:var(--color-danger-light); font-weight: bold;">{{ expProfit }} {{ this.sellAsset }} ({{ expProfitPct }}%)</span>
          </div>
          <div v-if="expProfitPct >= 0" style="margin-top: 30px;">
            {{ $text.tr('Ожидаемая прибыль:') }} <span style="font-size: 14px;color: var(--color-success-light); font-weight: bold;">{{ expProfit }} {{ this.sellAsset }} ({{ stepsProfitPct }}%)</span>
          </div>
        </div>
      </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Api from '@/util/api'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import Decimal from 'decimal.js'
import terminal from '@/services/terminal'
import util from '@/util/util'

export default {
  name: 'SlTpModal',
  data: function () {
    return {
      stopLossPrice: 0,
      sellAsset: '',
      stopLossPct: 0,
      stopLossPct2: 0,
      stopLossShow: true,
      takeProfitShow: true,
      takeProfitPrice: 0,
      takeProfitPct: 0,
      sltpIndex: 0,
      valuationAsset: 'USD',
      slTrailing: false,
      tpTrailing: false,
      tpTrailingPct: 1,
      showAddTarget: false,
      showAddSteps: true,
      showStepsTable: false,
      showPriceAndPct: true,
      stepAmountPct: 50,
      steps: [],
      maxStepPct: 100.0,
      side: 'B',
      qty: 0,
      loading: true,
      buyPriceEditing: false,
      qtyError: '',
      slpriceError: '',
      tppriceError: '',
      slAmountError: '',
      tpAmountError: '',
      tpStepAmountError: '',
      asset: '',
      symbol: '',
      buyPrice: ''
    }
  },
  watch: {
    '$store.state.sltpModal': function (showModal) {
      if (showModal) {
        this.initSltpModal()
      }
    },
    stepAmountPct: function () {
      this.checkErrors()
    },
    tpTrailingPct () {
      this.checkErrors()
    },
    tpTrailing () {
      this.checkErrors()
    }
  },

  computed: {
    editStepProfit () {
      // console.log('1:', this.takeProfitPrice)
      if (this.qty === '' || !this.takeProfitPrice) {
        return new Decimal(0)
      }
      let stepAmount = 100
      if (this.showAddTarget) {
        stepAmount = this.stepAmountPct
      }
      return new Decimal(this.takeProfitPrice).sub(this.buyPrice).mul('0.01').mul(stepAmount).mul(this.qty)
    },
    stepsProfitPct () {
      if (this.qty === '' || this.qty === '0') {
        return '0'
      }
      return new Decimal(this.stepsProfit).div(new Decimal(this.buyPrice).mul(this.qty)).mul(100).toDP(2).toString()
    },
    stepsProfit () {
      const self = this
      let profit = new Decimal(0)
      this.steps.forEach(function (step) {
        const stepPft = new Decimal(step.Price).sub(self.buyPrice).mul(step.Qty)
        profit = profit.add(stepPft)
      })
      if (this.showPriceAndPct) {
        profit = profit.add(this.editStepProfit)
      }
      if (this.side === 'S') {
        profit = profit.neg()
      }
      return profit.toDP(8).toString()
    },
    // buyPrice () {
    //   return this.curAssetBuyPrices[this.sellAsset]
    // },
    calculatedProfitPct () {
      // console.log('cur price: ' + this.curAssetPrices[this.sellAsset])
      if (this.curAssetPrices[this.sellAsset]) {
        const prof = new Decimal(this.curAssetPrices[this.sellAsset]).sub(this.buyPrice).mul(100).div(this.buyPrice).toString()
        return prof
      }
      return '0'
    },
    minFloat () {
      if (this.$store.state.sltpIndex < 0 || this.curAsset.Status === 'ORDSUBMIT') {
        return 0.1
      }
      if (this.calculatedProfitPct) {
        return parseFloat(this.calculatedProfitPct)
      } else {
        return 0.1
      }
    },
    maxFloat () {
      if (this.$store.state.sltpIndex < 0 || this.curAsset.Status === 'ORDSUBMIT') {
        return -0.1
      }
      if (this.calculatedProfitPct) {
        return parseFloat(this.calculatedProfitPct)
      } else {
        return -0.1
      }
    },
    expLossPct () {
      let prof = ((this.stopLossPrice - parseFloat(this.buyPrice)) * 100 / parseFloat(this.buyPrice)).toFixed(2)
      if (this.side === 'S') {
        prof = -1 * prof
      }
      return prof
    },
    expProfitPct () {
      let prof = ((this.takeProfitPrice - parseFloat(this.buyPrice)) * 100 / parseFloat(this.buyPrice)).toFixed(2)
      if (this.side === 'S') {
        prof = -1 * prof
      }
      return prof
    },
    expProfitPctOLD () {
      let prof = ((this.takeProfitPrice - this.curAsset.Price) * 100 / this.curAsset.Price).toFixed(2)
      if (this.side === 'S') {
        prof = -1 * prof
      }
      return prof
    },
    expLoss () {
      if (this.qty === '') {
        return '0'
      }
      let prof = new Decimal(this.stopLossPrice).sub(this.buyPrice).mul(this.qty).toDP(8)
      if (this.side === 'S') {
        prof = prof.neg()
      }
      return prof.toString()
    },
    // expLossBTC() {
    //   return ((this.stopLossPrice - parseFloat(this.curAsset.BuyPriceBTC)) * this.curAsset.Qty).toFixed(6)
    // },
    expProfit () {
      // var prof = ((this.takeProfitPrice - parseFloat(this.buyPrice)) * this.qty).toFixed(2)
      // if (this.side === 'S') {
      //   prof = -1 * prof
      // }
      // return prof
      return this.stepsProfit
    },
    expProfitOLD () {
      let prof = ((this.takeProfitPrice - parseFloat(this.curAsset.Price)) * this.curAsset.Qty).toFixed(2)
      if (this.side === 'S') {
        prof = -1 * prof
      }
      return prof
    },
    // expProfitBTC() {
    //   return ((this.takeProfitPrice - parseFloat(this.curAsset.BuyPriceBTC)) * this.curAsset.Qty).toFixed(6)
    // },
    profit () {
      if (this.curAsset) {
        return this.curAsset.Profit
      }
      return '0'
    },
    // profitBTC() {
    //   return ((parseFloat(this.curAsset.PriceBTC) - parseFloat(this.curAsset.BuyPriceBTC)) * this.curAsset.Qty).toFixed(6)
    // },
    profitPct () {
      return this.curAsset.ProfitPct
    },
    // profitPctBTC() {
    //   return ((this.curAsset.PriceBTC - this.curAsset.BuyPriceBTC) * 100 / this.curAsset.BuyPriceBTC).toFixed(2)
    // },
    curAsset () {
      let res = {}

      if (this.$store.state.sltpTrade) {
        if (this.$store.state.sltpIndex < 0) {
          // new trade mode
          const sltpo = {
            SlPrice: this.$store.state.trade.slprice,
            TpPrice: this.$store.state.trade.tpprice,
            SlTrailPct: this.$store.state.trade.sltrail,
            TpTrailPct: this.$store.state.trade.tptrail,
            Steps: { Steps: this.$store.state.trade.tpsteps }
          }
          res = {
            Price: this.$store.state.trade.price,
            Qty: this.$store.state.trade.qty,
            Side: this.$store.state.trade.side,
            Symbol: this.$store.state.trade.symbol,
            PriceNow: this.$store.state.sys.lastPrice,
            Coin: this.$store.state.trade.symbol.split('_')[0],
            QuoteAssets: [{
              Asset: this.$store.state.trade.symbol.split('_')[1],
              Price: this.$store.state.sys.lastPrice,
              BuyPrice: this.$store.state.trade.price
            }]
          }
          if (this.$store.state.trade.slprice > 0 || this.$store.state.trade.tpprice > 0) {
            res.Sltp = sltpo
          }
          return res
        } else {
          // trade mode
          if (this.$store.state.trades.data.Trades[this.$store.state.sltpIndex]) {
            return this.$store.state.trades.data.Trades[this.$store.state.sltpIndex]
          } else {
            return {}
          }
        }
      } else {
        // create smart sell
        const asset2 = this.$store.state.assets.data[this.$store.state.sltpIndex].QuoteAssets[0].Asset // ? this.$store.state.assetsData[this.sltpIndex].QuoteAssets[0].Asset : ''
        res = {
          Price: this.$store.state.assets.data[this.$store.state.sltpIndex].Price.U,
          Qty: this.$store.state.assets.data[this.$store.state.sltpIndex].Free,
          Side: 'B',
          Symbol: this.$store.state.assets.data[this.$store.state.sltpIndex].Coin + '_' + asset2,
          PriceNow: this.$store.state.assets.data[this.$store.state.sltpIndex].Price.U,
          QuoteAssets: this.$store.state.assets.data[this.$store.state.sltpIndex].QuoteAssets,
          Coin: this.$store.state.assets.data[this.$store.state.sltpIndex].Coin
        }
        // console.log('sltpIndex: ' + this.sltpIndex + ' symbol: ' + res.Symbol)
        return res
      }
    },
    curAssetPrices () {
      const prices = {}
      if (this.curAsset.QuoteAssets) {
        this.curAsset.QuoteAssets.forEach(element => {
          prices[element.Asset] = element.Price
        })
      }
      return prices
    },
    curAssetBuyPrices () {
      const prices = {}
      if (this.curAsset.QuoteAssets) {
        this.curAsset.QuoteAssets.forEach(element => {
          prices[element.Asset] = element.BuyPrice
        })
      }
      return prices
    }
    // stopLossPrice: {
    //   get() {
    //     // return new Decimal(this.price).times(this.amount).toDP(8)
    //
    //     // this.stopLossPrice = this.data1[params.index].PriceUSD - this.data1[params.index].PriceUSD * 0.1
    //     // return parseFloat(this.curAsset.PriceUSD) + parseFloat(this.curAsset.PriceUSD * this.stopLossPct * 0.01)
    //   },
    //   set(newValue) {
    //     // this.amount = new Decimal(newValue).dividedBy(this.price).toDP(8)
    //     this.stopLossPct = 100 * newValue / parseFloat(this.curAsset.PriceUSD) - 100
    //   }
    // }
  },

  methods: {
    showError (error) {
      if (error) {
        this.$Message.error(util.returnTextForErr(error))
      }
    },
    buyPriceChanged () {
      if (parseFloat(this.buyPrice) > 0) {
        if (this.takeProfitPct < this.minFloat) {
          this.takeProfitPct = this.minFloat
        } else if (this.takeProfitPct > this.maxFloat) {
          this.takeProfitPct = this.maxFloat
        }
        if (this.stopLossPct < this.minFloat) {
          this.stopLossPct = this.minFloat
        } else if (this.stopLossPct > this.maxFloat) {
          this.stopLossPct = this.maxFloat
        }
        this.takeProfitPriceChanged(this.takeProfitPrice)
        this.stopLossPriceChanged(this.stopLossPrice)
      }
    },
    onkeyDown (txt, e) {
      // alert(e.keyCode)

      // console.log(txt)
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return
      }

      // Allow: Ctrl+V
      // if (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) {
      //   this.$store.state.trade.qty = this.$store.state.trade.qty.replace(/[^\d.-]/g, '')
      //   return
      // }

      // console.log(this.$store.state.trade.qty + ' ' + this.$store.state.trade.qty.includes('.'))
      // console.log(typeof this.$store.state.trade.qty)
      // console.log(e.target.value)
      // console.log(e.code)
      if (e.keyCode === 190) {
        if (txt.includes('.')) {
          e.preventDefault()
          // } else if (e.target.value === 'ю') {
          //   e.target.value = '.'
        } else {
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    },
    numAfterDot (numb) {
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      // console.log(numb)
      // console.log(typeof numb)
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    checkErrors () {
      const symb1 = this.asset + '_' + this.sellAsset

      const priceDec = this.$store.state.data.symbolsfilter[symb1].PriceDec
      const qtyDec = this.$store.state.data.symbolsfilter[symb1].QtyDec
      let amountMin = this.$store.state.data.symbolsfilter[symb1].AmountMin
      amountMin = new Decimal(1.05).mul(amountMin).toString()
      let ordsubmit = false

      if (this.curAsset.Status) {
        ordsubmit = this.curAsset.Status === 'ORDSUBMIT'
      }
      // console.log('this.curAsset.Status', this.curAsset.Status, ordsubmit)

      if (this.stopLossShow) {
        // для новой сделки стоп лосс должен быть ниже цены покупки
        // для активной сделки - ниже текущей цены
        if (this.$store.state.sltpIndex >= 0 && !ordsubmit && this.side === 'B' && new Decimal(this.stopLossPrice).greaterThanOrEqualTo(this.curAssetPrices[this.sellAsset])) {
          this.slpriceError = this.$text.tr('Stop Loss должен быть ниже текущей цены')
        } else if (this.$store.state.sltpIndex >= 0 && !ordsubmit && this.side === 'S' && new Decimal(this.stopLossPrice).lessThanOrEqualTo(this.curAssetPrices[this.sellAsset])) {
          this.slpriceError = this.$text.tr('Stop Loss  должен быть выше текущей цены')
        } else if ((this.$store.state.sltpIndex < 0 || ordsubmit) && this.side === 'B' && new Decimal(this.stopLossPrice).greaterThanOrEqualTo(this.buyPrice)) {
          this.slpriceError = this.$text.tr('Stop Loss должен быть ниже цены покупки')
        } else if ((this.$store.state.sltpIndex < 0 || ordsubmit) && this.side === 'S' && new Decimal(this.stopLossPrice).lessThanOrEqualTo(this.buyPrice)) {
          this.slpriceError = this.$text.tr('Stop Loss должен быть выше цены покупки')
        } else if (this.numAfterDot(this.stopLossPrice) > priceDec) {
          this.slpriceError = this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
        } else {
          this.slpriceError = ''
        }

        if (this.qty > 0 && this.side === 'B' && new Decimal(this.stopLossPrice).mul(this.qty).lessThan(amountMin)) {
          // this.slAmountError = 'Минимальная сумма: ' + amountMin + ' Цена должна быть выше ' + new Decimal(amountMin).div(this.qty).toDP(priceDec, Decimal.ROUND_DOWN).toString()
          this.slAmountError = this.$text.tr('Ордер меньше минимального. Цена должна быть выше ') + new Decimal(amountMin).div(this.qty).toDP(priceDec, Decimal.ROUND_DOWN).toString()
        } else {
          this.slAmountError = ''
        }
      } else {
        this.slpriceError = ''
        this.slAmountError = ''
      }

      if (this.takeProfitShow) {
        if (this.$store.state.sltpIndex >= 0 && !ordsubmit && this.side === 'B' && new Decimal(this.takeProfitPrice).lessThanOrEqualTo(this.curAssetPrices[this.sellAsset])) {
          this.tppriceError = this.$text.tr('Take Profit должен быть выше текущей цены')
        } else if (this.$store.state.sltpIndex >= 0 && !ordsubmit && this.side === 'S' && new Decimal(this.takeProfitPrice).greaterThanOrEqualTo(this.curAssetPrices[this.sellAsset])) {
          this.tppriceError = this.$text.tr('Take Profit должен быть ниже текущей цены')
        } else if ((this.$store.state.sltpIndex < 0 || ordsubmit) && this.side === 'B' && new Decimal(this.takeProfitPrice).lessThanOrEqualTo(this.buyPrice)) {
          this.tppriceError = this.$text.tr('Take Profit должен быть выше цены покупки')
        } else if ((this.$store.state.sltpIndex < 0 || ordsubmit) && this.side === 'S' && new Decimal(this.takeProfitPrice).greaterThanOrEqualTo(this.buyPrice)) {
          this.tppriceError = this.$text.tr('Take Profit должен быть ниже цены покупки')
        } else if (this.numAfterDot(this.takeProfitPrice) > priceDec) {
          this.tppriceError = this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
        } else {
          this.tppriceError = ''
        }

        let tpPrice = new Decimal(this.takeProfitPrice)
        let minPrice = new Decimal(amountMin).div(this.qty).toDP(priceDec, Decimal.ROUND_DOWN)
        if (this.tpTrailing) {
          tpPrice = new Decimal(1).sub(new Decimal(this.tpTrailingPct).mul(0.01)).mul(tpPrice)
          minPrice = minPrice.div(new Decimal(1).sub(new Decimal(this.tpTrailingPct).mul(0.01))).toDP(priceDec, Decimal.ROUND_DOWN)
        }
        if (this.qty > 0 && tpPrice.mul(this.qty).lessThan(amountMin)) {
          // this.slAmountError = 'Минимальная сумма: ' + amountMin + ' Цена должна быть выше ' + new Decimal(amountMin).div(this.qty).toDP(priceDec, Decimal.ROUND_DOWN).toString()
          this.tpAmountError = this.$text.tr('Ордер меньше минимального. Цена должна быть выше ') + minPrice.toString()
        } else {
          this.tpAmountError = ''
        }

        if (this.showAddTarget && this.qty > 0) {
          // console.log('qtyDec:', qtyDec)
          const qty1 = new Decimal(this.qty).mul(this.takeProfitPrice).mul(this.stepAmountPct).mul('0.01').toDP(8)
          const x = new Decimal(amountMin).div(this.qty).div(this.takeProfitPrice).div('0.01').toDP(0)
          // console.log('qty1:', qty1.toString(), 'x:', x.toString(), 'stepAmountPct:', this.stepAmountPct, ' amountMin:', amountMin)
          if (qty1.lessThan(amountMin)) {
            this.tpStepAmountError = this.$text.tr('Кол-во должно быть больше ') + x + '%'
          } else {
            this.tpStepAmountError = ''
          }
        } else {
          this.tpStepAmountError = ''
        }
      } else {
        this.tppriceError = ''
        this.tpAmountError = ''
      }

      if (this.numAfterDot(this.qty) > qtyDec) {
        this.qtyError = this.$text.tr('Максимальное число знаков после запятой: ') + qtyDec
      } else if (this.$store.state.sltpIndex >= 0 && (this.qty === '' || parseFloat(this.qty) === 0)) {
        this.qtyError = this.$text.tr('Кол-во должно быть больше 0')
      } else if (new Decimal(this.qty).greaterThan(this.curAsset.Qty)) {
        this.qtyError = this.$text.tr('Недостаточно средств')
      } else {
        this.qtyError = ''
      }
    },
    editBuyPrice () {
      this.buyPriceEditing = true
    },
    slAssetChanged () {
      // var index = this.curAsset.QuoteAssets.findIndex(x => x.Asset === this.sellAsset)
      // this.stopLossPriceChanged(this.curAssetPrices[this.sellAsset])

      this.stopLossPctChanged(this.stopLossPct)
      this.takeProfitPctChanged(this.takeProfitPct)
    },
    formUrl () {
      let url = ''
      if (this.stopLossShow) {
        url += '&sl_price=' + this.stopLossPrice
      }

      if (this.takeProfitShow) {
        if (this.steps.length > 0) {
          url += '&tp_price=' + this.steps[0].Price
          let steps = ''
          this.steps.forEach(step => {
            // steps += step.Price + ':' + step.Pct + ':' + step.Qty + ':' + step.Status + ','
            steps += ':true:' + step.Price + ':' + step.Pct + ':' + step.Qty + ':ACT,'
          })
          url += '&tp_steps=' + steps
        } else {
          url += '&tp_price=' + this.takeProfitPrice
          url += '&tp_steps=:true:' + this.takeProfitPrice + ':100:' + this.qty + ':ACT'
        }
      }

      if (this.slTrailing) {
        const slPct2 = 100 * this.stopLossPrice / parseFloat(this.curAsset.PriceNow) - 100
        url += '&sl_trail_pct=' + new Decimal(slPct2).abs().toDP(8).toString()
      }

      if (this.tpTrailing) {
        url += '&tp_trail_pct=' + this.tpTrailingPct
      }

      return url
    },
    modalError () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    },
    amount100 () {
      const symb1 = this.asset + '_' + this.sellAsset
      const qtyDec = this.$store.state.data.symbolsfilter[symb1].QtyDec
      this.qty = new Decimal(this.curAsset.Qty).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
      this.checkErrors()
      // this.qty = this.curAsset.Qty
    },
    ok () {
      const ref = this

      // console.log('errs:', this.slpriceError, this.tppriceError, this.qtyError)

      if ((this.slpriceError !== '' || this.tppriceError !== '' || this.slAmountError !== '' || this.tpAmountError !== '')) {
        this.showError(this.slpriceError)
        this.showError(this.tppriceError)
        this.showError(this.slAmountError)
        this.showError(this.tpAmountError)
        this.modalError()
        return
      }

      if (this.steps.length > 0 && this.maxStepPct > 0) {
        this.$Message.error(this.$text.tr('Нужно распределить весь актив'))
        this.modalError()
        return
      }

      if (this.$store.state.sltpTrade) {
        if (this.$store.state.sltpIndex < 0) {
          // NEW TRADE MODE
          if (this.stopLossShow) {
            this.$store.state.trade.slprice = this.stopLossPrice
          } else {
            this.$store.state.trade.slprice = 0
          }
          if (this.takeProfitShow) {
            this.$store.state.trade.tpprice = this.takeProfitPrice
            this.$store.state.trade.tpsteps = this.steps
            if (this.steps.length > 0) {
              this.$store.state.trade.tpprice = this.steps[0].Price
            }
          } else {
            this.$store.state.trade.tpprice = 0
          }
          if (this.slTrailing) {
            const slPct = 100 * this.stopLossPrice / parseFloat(this.curAsset.PriceNow) - 100
            this.$store.state.trade.sltrail = new Decimal(slPct).abs().toDP(8).toString()
          } else {
            this.$store.state.trade.sltrail = 0
          }
          if (this.tpTrailing) {
            this.$store.state.trade.tptrail = this.tpTrailingPct
          } else {
            this.$store.state.trade.tptrail = 0
          }
          this.$store.state.sltpModal = false
        } else {
          // TRADE MODE
          let url = 'trade/set_sltp?token=' + this.$store.state.sys.token + '&etid=' + this.$store.state.sys.tradeExchange.Id +
            '&trade_id=' + this.curAsset.Id

          url += this.formUrl()

          // console.log('set sltp url', url)

          Api
            .get(url)
            .then(function (response) {
              // console.log(response.data)
              // ref.updateExchanges()
              ref.$Message.info('Stop Loss & Take Profit установлены')
              // ref.updateBalance()
              ref.$store.state.sys.lastTrade = Date.now()
              // ref.$store.dispatch('updateAssets')
            })
            .catch(function (error) {
              console.log(error)
              ref.$Message.error(ref.$text.tr('Ошибка') + ': ' + util.returnTextForErr(error))
            })

          if (this.$store.state.trade.editTrade && this.$store.state.trade.editTrade.Id === this.curAsset.Id) {
            // console.log('edit trade refreshing')
            setTimeout(() => {
              terminal.tradeGetAndSet(this.curAsset.Id)
            }, 100)
          }
          this.$store.state.sltpModal = false
        }
      } else {
        // SMART SELL MODE
        let url1 = 'trade/create?token=' + this.$store.state.sys.token + '&etid=' + this.$store.state.sys.tradeExchange.Id

        url1 += '&qty=' + this.qty +
        '&symbol=' + this.curAsset.Coin + '_' + this.sellAsset +
        '&price=' + this.buyPrice

        url1 += this.formUrl()

        // console.log('url1:', url1)

        // var ref = this
        SlimApis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get(url1)
          .then((response) => {
            // console.log('response:', response.data)
            if (!response.data.err) {
              ref.$Notice.success({
                title: ref.$text.tr('Сделка создана'),
                duration: 6
              })
              this.$store.state.sys.lastTrade = Date.now()
              this.$store.state.sltpModal = false
            } else {
              // ref.$Message.error('Ошибка: ' + response.data.err)
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: util.returnTextForErr(response.data.err),
                duration: 10
              })
              this.modalError()
            }
          })
          .catch(function (error) {
            console.log(error)
            ref.$Message.error(ref.$text.tr('Ошибка'))
          })
        // this.$Message.error('Ошибка: заполните все поля')
        // this.modalError()
      }
    },
    cancel () {
      // this.$Message.info('Clicked cancel')
    },
    qtyChangedEvent (event) {
      this.qty = event.target.value.replace('ю', '.').replace(/[^\d.-]/g, '')
      if (this.qty.charAt(0) === '0' && this.qty.charAt(1) !== '.') {
        this.qty = this.qty.substring(1)
      }
      this.recalStepsQty()
      // this.takeProfitPriceChanged(event.target.value)
      this.checkErrors()
    },
    stopLossPctChanged (newPct) {
      this.stopLossPct = newPct
      // this.stopLossPrice = (parseFloat(this.curAsset.PriceNow) + parseFloat(this.curAsset.PriceNow * newPct * 0.01)).toPrecision(6)
      const symb1 = this.asset + '_' + this.sellAsset
      const priceDec = this.$store.state.data.symbolsfilter[symb1].PriceDec

      this.stopLossPrice = new Decimal(this.buyPrice).add(new Decimal(this.buyPrice).mul(newPct).mul('0.01')).toDP(priceDec).toString()
      // this.stopLossPrice = (parseFloat(this.curAssetPrices[this.sellAsset]) + parseFloat(this.curAssetPrices[this.sellAsset] * newPct * 0.01)).toPrecision(6)
      this.checkErrors()
    },
    stopLossPriceChangedEvent (event) {
      this.stopLossPrice = event.target.value.replace('ю', '.').replace(/[^\d.-]/g, '')
      if (this.stopLossPrice.charAt(0) === '0' && this.stopLossPrice.charAt(1) !== '.') {
        this.stopLossPrice = this.stopLossPrice.substring(1)
      }
      this.stopLossPriceChanged(event.target.value)
      // this.total = new Decimal(this.$store.state.trade.qty).mul(this.$store.state.trade.price).toDP(8).toString()
      this.checkErrors()
    },
    stopLossPctChangedEvent (event) {
      this.stopLossPctChanged(event)
    },
    stopLossPriceChanged (newPrice) {
      this.stopLossPrice = newPrice
      this.stopLossPct = 100 * newPrice / parseFloat(this.buyPrice) - 100
    },
    takeProfitPctChanged (newPct) {
      this.takeProfitPct = newPct

      const symb1 = this.asset + '_' + this.sellAsset
      const priceDec = this.$store.state.data.symbolsfilter[symb1].PriceDec

      this.takeProfitPrice = new Decimal(this.buyPrice).add(new Decimal(this.buyPrice).mul(newPct).mul('0.01')).toDP(priceDec).toString()
      this.checkErrors()
      // this.takeProfitPrice = (parseFloat(this.curAsset.PriceNow) + parseFloat(this.curAsset.PriceNow * newPct * 0.01)).toPrecision(6)
      // this.takeProfitPrice = (parseFloat(this.curAssetPrices[this.sellAsset]) + parseFloat(this.curAssetPrices[this.sellAsset] * newPct * 0.01)).toPrecision(6)
    },
    takeProfitPriceChangedEvent (event) {
      this.takeProfitPrice = event.target.value.replace('ю', '.').replace(/[^\d.-]/g, '')
      if (this.takeProfitPrice.charAt(0) === '0' && this.takeProfitPrice.charAt(1) !== '.') {
        this.takeProfitPrice = this.takeProfitPrice.substring(1)
      }
      this.takeProfitPriceChanged(event.target.value)
      this.checkErrors()
    },
    takeProfitPctChangedEvent (event) {
      this.takeProfitPctChanged(event)
    },
    takeProfitPriceChanged (newPrice) {
      this.takeProfitPrice = newPrice
      this.takeProfitPct = 100 * newPrice / parseFloat(this.buyPrice) - 100
    },
    sltpAssetChanged () {
      // var index = this.curAsset.QuoteAssets.findIndex(x => x.Asset === this.sellAsset)
      // this.stopLossPriceChanged(this.curAsset.PriceNow)

      this.buyPrice = this.curAssetPrices[this.sellAsset]
      this.stopLossPctChanged(this.stopLossPct)
      this.takeProfitPctChanged(this.takeProfitPct)
      // this.curAssetBuyPrices[this.sellAsset] = this.curAssetPrices[this.sellAsset]
    },
    // expLossPct(asset) {
    //   if (asset === 'BTC') {
    //     return ((this.stopLossPrice - this.curAsset.BuyPriceBTC) * 100 / this.curAsset.BuyPriceBTC).toFixed(2)
    //   } else {
    //     return ((this.stopLossPrice - this.curAsset.BuyPriceUSD) * 100 / this.curAsset.BuyPriceUSD).toFixed(2)
    //   }
    // },
    // expProfitPct(asset) {
    //   if (asset === 'BTC') {
    //     return ((this.takeProfitPrice - this.curAsset.BuyPriceBTC) * 100 / this.curAsset.BuyPriceBTC).toFixed(2)
    //   } else {
    //     return ((this.takeProfitPrice - this.curAsset.BuyPriceUSD) * 100 / this.curAsset.BuyPriceUSD).toFixed(2)
    //   }
    // },
    addSteps () {
      // alert(1)
      this.showAddSteps = false
      this.showAddTarget = true
      this.checkErrors()
    },
    deleteStep (index) {
      this.maxStepPct += parseInt(this.steps[index].Pct)
      this.steps.splice(index, 1)
      // if (this.stepAmountPct === 0) {
      //   this.stepAmountPct = 1
      // }
      this.stepAmountPct = this.maxStepPct
      if (this.showPriceAndPct === false) {
        this.showAddTarget = true
        this.showPriceAndPct = true
      }
      if (this.steps.length === 0) {
        this.showAddSteps = true
        this.showAddTarget = false
        this.showStepsTable = false
        this.stepAmountPct = 50
      }
      this.checkErrors()
    },
    recalStepsQty () {
      // recalculate steps qty
      const qtyDec = this.$store.state.data.symbolsfilter[this.symbol].QtyDec
      let qtySum = new Decimal(0)
      let pctSum = new Decimal(0)
      this.steps.forEach((step, index) => {
        if (step.Pct) {
          pctSum = pctSum.add(step.Pct)
          if (pctSum.greaterThanOrEqualTo(100)) {
            // last step
            step.Qty = new Decimal(this.qty).sub(qtySum).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
          } else {
            step.Qty = new Decimal(this.qty).mul(step.Pct).mul('0.01').toDP(qtyDec, Decimal.ROUND_DOWN).toString()
          }
          qtySum = qtySum.add(step.Qty)
        }
      })
    },
    addTarget () {
      // alert(1)
      // this.showAddSteps = false;
      const qtyDec = this.$store.state.data.symbolsfilter[this.symbol].QtyDec
      let qty1 = new Decimal(this.qty).mul(this.stepAmountPct).mul('0.01').toDP(qtyDec, Decimal.ROUND_DOWN).toString()

      this.maxStepPct -= this.stepAmountPct

      // last step
      if (this.maxStepPct === 0) {
        this.showAddSteps = false
        this.showAddTarget = false
        this.showPriceAndPct = false
        const qtySteps = this.steps.reduce((prev, cur) => prev.add(cur.Qty), new Decimal(0))
        qty1 = new Decimal(this.qty).sub(qtySteps).toDP(qtyDec, Decimal.ROUND_DOWN).toString()
        // console.log(qtySteps.toString())
      }
      this.steps.push({
        Price: this.takeProfitPrice,
        Pct: this.stepAmountPct,
        Qty: qty1,
        Status: 'ACT'
      })
      let k = 1
      if (this.side === 'S') {
        k = -1
      }
      this.steps.sort((a, b) => {
        if (a.Status < b.Status) {
          return 1
        } else if (a.Status > b.Status) {
          return -1
        } else {
          return parseFloat(a.Price) >= parseFloat(b.Price) ? 1 * k : -1 * k
        }
      })

      if (this.stepAmountPct > this.maxStepPct) {
        this.stepAmountPct = this.maxStepPct
      }

      if (this.steps.length > 3) {
        this.showAddSteps = false
        this.showAddTarget = false
        this.showPriceAndPct = false
      }
      this.checkErrors()
      this.showStepsTable = true
    },
    initSltpModal () {
      // if (this.$store.state.sltpIndex < 0) {
      //   this.side = this.$store.state.trade.side
      // } else {

      this.asset = this.curAsset.Symbol.split('_')[0]

      let haveBtc = false
      let haveUsdt = false
      this.curAsset.QuoteAssets.forEach(asset => {
        if (asset.Asset === 'BTC') {
          haveBtc = true
        }
        if (asset.Asset === 'USDT') {
          haveUsdt = true
        }
      })
      if (haveBtc) {
        this.sellAsset = 'BTC'
      } else if (haveUsdt) {
        this.sellAsset = 'USDT'
      } else {
        this.sellAsset = this.curAsset.QuoteAssets[0].Asset
      }
      this.side = this.curAsset.Side
      this.symbol = this.asset + '_' + this.sellAsset

      this.stepAmountPct = 50

      const qtyDec = this.$store.state.data.symbolsfilter[this.symbol].QtyDec
      if (!this.$store.state.sltpTrade) {
        // this.buyPrice = this.curAsset.PriceNow
        this.buyPrice = this.curAssetPrices[this.sellAsset]
        // this.curAssetBuyPrices[this.sellAsset] = this.curAssetPrices[this.sellAsset]
        // var qtyDec = this.$store.state.data.symbolsfilter[this.symbol].QtyDec
        // this.qty = new Decimal(this.curAsset.Qty).toDP(qtyDec, Decimal.ROUND_DOWN).toNumber()
      } else {
        this.buyPrice = this.curAssetBuyPrices[this.sellAsset]
      }
      this.qty = new Decimal(this.curAsset.Qty).toDP(qtyDec, Decimal.ROUND_DOWN).toString()

      // console.log(this.curAsset)
      // console.log(this.$store.state.sltpIndex)

      // if (this.curAsset.Coin !== 'BTC') {
      //   this.sellAsset = 'BTC'
      // } else {
      //   if (this.$store.state.dexchange.exchId === 'BIN') {
      //     this.sellAsset = 'USDT'
      //   } else {
      //     this.sellAsset = 'USD'
      //   }
      // }

      if (this.curAsset.Sltp) {
        this.stopLossShow = false
        this.takeProfitShow = false
        this.stopLossPrice = this.curAsset.Sltp.SlPrice
        this.takeProfitPrice = this.curAsset.Sltp.TpPrice

        if (this.stopLossPrice && new Decimal(this.stopLossPrice).greaterThan(0)) {
          this.stopLossPriceChanged(this.stopLossPrice)
          this.stopLossShow = true
        } else {
          if (this.side === 'B') {
            this.stopLossPct = -10.0
          } else {
            this.stopLossPct = 10.0
          }
          this.stopLossPctChanged(this.stopLossPct)
        }
        // console.log('2:', this.takeProfitPrice)
        if (this.takeProfitPrice && new Decimal(this.takeProfitPrice).greaterThan(0)) {
          this.takeProfitPriceChanged(this.takeProfitPrice)
          this.takeProfitShow = true
        } else {
          if (this.side === 'B') {
            this.takeProfitPct = 20.0
          } else {
            this.takeProfitPct = -20.0
          }
          this.takeProfitPctChanged(this.takeProfitPct)
        }

        this.slTrailing = parseFloat(this.curAsset.Sltp.SlTrailPct) > 0

        this.tpTrailingPct = parseFloat(this.curAsset.Sltp.TpTrailPct)
        if (this.tpTrailingPct) {
          this.tpTrailing = this.tpTrailingPct > 0
        } else {
          this.tpTrailing = false
          this.tpTrailingPct = 1.0
        }

        this.steps = []
        if (this.curAsset.Sltp.Steps) {
          this.curAsset.Sltp.Steps.Steps.forEach(step => this.steps.push(step))
        }
        // console.log(this.steps)
        // все ступени установлены
        if (this.steps.length > 0) {
          this.showStepsTable = true
          this.maxStepPct = 0
          this.showPriceAndPct = false
          this.showAddTarget = false
          this.showAddSteps = false
        }
      } else {
        this.stopLossPct = -10.0
        this.takeProfitPct = 20.0
        if (this.side === 'S') {
          this.stopLossPct = 10.0
          this.takeProfitPct = -20.0
        }
        this.stopLossPctChanged(this.stopLossPct)
        this.takeProfitPctChanged(this.takeProfitPct)
        this.stopLossShow = false
        this.takeProfitShow = false
        this.slTrailing = false
        this.tpTrailing = false
        this.tpTrailingPct = 1.0
      }

      // this.steps = []
      if (!this.curAsset.Sltp || !this.curAsset.Sltp.Steps || this.curAsset.Sltp.Steps.Steps.length === 0) {
        this.steps = []
        this.showPriceAndPct = true
        this.showAddSteps = true
        this.showAddTarget = false
        this.showStepsTable = false
        this.maxStepPct = 100
      } else {
        // var tpSteps = this.curAsset.Sltp.TpSteps.split(',')
        // var totalQty = 0
        // tpSteps.forEach(step => {
        //   var priceandqty = step.split(':')
        //   this.steps.push({price: priceandqty[0], perc: priceandqty[1]})
        //   totalQty += parseInt(priceandqty[1])
        // })
        // this.maxStepPct = 100 - totalQty
        // // console.log('maxStepPct: ' + this.maxStepPct)
        // if (this.maxStepPct === 0.0 || tpSteps.length > 3) {
        //   this.showPriceAndPct = false
        //   this.showAddTarget = false
        // } else {
        //   this.showPriceAndPct = true
        //   this.showAddTarget = true
        // }
        // this.showAddSteps = false
        // this.showStepsTable = true
      }

      // }
      // if (this.stopLossPrice === 0 && this.takeProfitPrice === 0) {
      //   if (this.curAsset.Sltp.Asset !== 'BTC') {
      //     this.sellAsset = 'BTC'
      //   } else {
      //     if (this.$store.state.dexchange === 'YOB') {
      //       this.sellAsset = 'USD'
      //     } else {
      //       this.sellAsset = 'USDT'
      //     }
      //   }
      // } else {
      //   this.sellAsset = this.curAsset.Sltp.SellAsset
      //   // console.log('sellAsset: ' + this.sellAsset)
      // }

      // this.sellAsset = this.curAsset.Symbol.split('_')[1]

      // this.stopLossPriceChanged(this.stopLossPrice)
      // this.stopLossShow = true
      // if (this.stopLossPrice === 0) {
      //   this.stopLossPct = -10.0
      //   this.stopLossPctChanged(this.stopLossPct)
      //   this.stopLossShow = false
      // }
      // this.takeProfitPriceChanged(this.takeProfitPrice)
      // this.takeProfitShow = true
      // console.log(this.takeProfitPrice)
      // if (this.takeProfitPrice === 0) {
      //   this.takeProfitPct = 30.0
      //   this.takeProfitPctChanged(this.takeProfitPct)
      //   this.takeProfitShow = false
      // }

      this.checkErrors()
      this.$store.state.sltpModal = true
    }
  }
}
</script>
